import { BXEVN, VERSION } from './default.js'

var DEFAULT_SOURCE = 'bx-gaosiweb'
var LOG_GROUP = 'axx'
var LOG_STORE = BXEVN === 'prod' ? 'user-log' : 'user-log-test'
var TRACK_ENDPOINT = 'https://' + LOG_GROUP + '-logs.cn-beijing.log.aliyuncs.com/logstores/' + LOG_STORE + '/track.gif'
var SENSITIVE_KEYS = [
  'password',
  'Password',
  'verificationCode',
  'VerificationCode',
  'captcha',
  'captchaCode',
  'captcha_code',
  'token',
  'Token',
  'LoginToken',
  'uToken',
  'ptoken',
  'PToken',
  'sign'
]

var appInfo = {
  source: DEFAULT_SOURCE,
  appName: '高思官网',
  appKey: DEFAULT_SOURCE,
  partnerId: '',
  version: VERSION
}

var inited = false
var lastClickPath = ''
var lastClickTime = 0

function extend(target, source) {
  target = target || {}
  source = source || {}
  Object.keys(source).forEach(function(key) {
    target[key] = source[key]
  })
  return target
}

function getStoredUser() {
  try {
    var rawUser = localStorage.getItem('user')
    return rawUser ? JSON.parse(rawUser) : {}
  } catch (error) {
    return {}
  }
}

function getQueryValue(name) {
  var search = window.location.search || ''
  if (search.charAt(0) === '?') {
    search = search.slice(1)
  }
  var parts = search.split('&')
  for (var i = 0; i < parts.length; i++) {
    var pair = parts[i].split('=')
    if (decodeURIComponent(pair[0] || '') === name) {
      return decodeURIComponent(pair[1] || '')
    }
  }
  return ''
}

function getCurrentChannel() {
  return (
    getQueryValue('channel') ||
    localStorage.getItem('APP_CHANNEL') ||
    localStorage.getItem('CHANNEL') ||
    localStorage.getItem('channel') ||
    ''
  )
}

function getUuid() {
  function s4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  var id = localStorage.getItem('md_u2')
  if (!id) {
    id = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
    localStorage.setItem('md_u2', id)
  }
  return id
}

function getUserTrackBaseInfo() {
  var user = getStoredUser()

  return {
    userId: user.UserId || user.user_id || localStorage.getItem('userId') || '',
    studentName: user.Name || user.name || '',
    studentCode: user.Code || user.StudentCode || user.code || '',
    axgStudentId: user.StudentId || localStorage.getItem('axgStudentId') || '',
    channel: getCurrentChannel(),
    source: appInfo.source,
    appName: appInfo.appName,
    appKey: appInfo.appKey,
    partnerId: appInfo.partnerId,
    version: appInfo.version
  }
}

function sanitizeParams(params) {
  if (!params || typeof params !== 'object') {
    return params || {}
  }

  var result = Object.prototype.toString.call(params) === '[object Array]' ? [] : {}
  Object.keys(params).forEach(function(key) {
    var value = params[key]
    if (SENSITIVE_KEYS.indexOf(key) > -1) {
      result[key] = '***'
    } else if (value && typeof value === 'object') {
      result[key] = sanitizeParams(value)
    } else {
      result[key] = value
    }
  })
  return result
}

function stringify(data) {
  var result = []
  Object.keys(data).forEach(function(key) {
    var value = data[key]
    if (value && typeof value === 'object') {
      value = JSON.stringify(value)
    }
    result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value))
  })
  return result.join('&')
}

function maskUrl(url) {
  if (!url) return ''
  return String(url)
    .replace(/([?&](?:LoginToken|loginToken|token|ptoken|PToken|sign)=)[^&]*/g, '$1***')
}

function maskText(text) {
  if (!text) return ''
  return String(text)
    .replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2')
    .replace(/([a-zA-Z0-9_-]{1})[a-zA-Z0-9_-]+@/g, '$1***@')
}

function buildBasePayload(extra) {
  var origin = window.location.origin || (window.location.protocol + '//' + window.location.host)
  var base = {
    APIVersion: '0.6.0',
    u2: getUuid(),
    r_url: document.referrer ? encodeURIComponent(document.referrer) : '',
    url: encodeURIComponent(origin + window.location.pathname),
    et: new Date().getTime(),
    w: screen.width || 0,
    h: screen.height || 0,
    ua: navigator.userAgent,
    pd: 'DXEDij',
    pad: 'gs-family-user-track',
    evt: 'imp'
  }
  return extend(base, extra || {})
}

function sendTrack(data) {
  try {
    var payload = buildBasePayload(data)
    var img = new Image()
    img.src = TRACK_ENDPOINT + '?' + stringify(payload)
  } catch (error) {
    console.warn('用户轨迹上报失败', error)
  }
}

function getElementPath(element) {
  if (!element || !element.nodeType) return ''
  var paths = []
  var current = element
  while (current && current.nodeType === 1 && paths.length < 6) {
    var name = current.nodeName.toLowerCase()
    if (current.id) {
      name += '#' + current.id
      paths.unshift(name)
      break
    }
    if (current.className && typeof current.className === 'string') {
      name += '.' + current.className.split(/\s+/).slice(0, 2).join('.')
    }
    paths.unshift(name)
    current = current.parentNode
  }
  return paths.join(' > ')
}

function getTrackTarget(element) {
  var current = element
  while (current && current !== document.body) {
    if (/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/i.test(current.tagName) || current.getAttribute('data-track') || current.getAttribute('onclick')) {
      return current
    }
    current = current.parentNode
  }
  return element
}

function getElementText(element) {
  if (!element) return ''
  if (element.tagName === 'INPUT' && element.type === 'password') return '[PASSWORD_MASKED]'
  if (element.getAttribute && element.getAttribute('data-name')) return element.getAttribute('data-name')
  if (/^(INPUT|TEXTAREA|SELECT)$/i.test(element.tagName)) {
    return maskText(element.value || element.placeholder || '')
  }
  if (element.tagName === 'IMG') {
    return element.alt || 'IMAGE'
  }
  return maskText((element.innerText || element.textContent || '').replace(/\s+/g, ' ').trim()).substring(0, 50)
}

function trackClick(event) {
  var target = getTrackTarget(event.target)
  var path = getElementPath(target)
  var now = new Date().getTime()

  if (!path || (path === lastClickPath && now - lastClickTime < 500)) {
    return
  }

  lastClickPath = path
  lastClickTime = now

  var pp1 = {
    trackType: 'click',
    trackName: getElementText(target),
    path: path,
    tag: target.tagName,
    title: document.title || '',
    id: target.id || '',
    'class': target.className || '',
    x: event.clientX,
    y: event.clientY,
    url: maskUrl(window.location.href)
  }
  var pp2 = getUserTrackBaseInfo()

  sendTrack({
    trackType: 'click',
    trackName: pp1.trackName,
    pp1: pp1,
    pp2: pp2,
    pp1String: JSON.stringify(pp1),
    pp2String: JSON.stringify(pp2)
  })
}

export function initUserTrack(options) {
  appInfo = extend(extend({}, appInfo), options || {})
  if (inited) {
    return
  }
  inited = true
  document.addEventListener('click', trackClick, true)
}

export function trackPageView(route) {
  var pp1 = {
    trackType: 'pv',
    trackName: 'PV ' + ((route && route.path) || window.location.pathname),
    title: (route && route.meta && route.meta.title) || document.title || '',
    path: (route && route.path) || window.location.pathname,
    url: maskUrl(window.location.href),
    referrer: maskUrl(document.referrer || ''),
    extra: {
      name: (route && route.name) || '',
      fullPath: (route && route.fullPath) || ''
    }
  }
  var pp2 = getUserTrackBaseInfo()

  sendTrack({
    trackType: 'pv',
    trackName: pp1.trackName,
    pp1: pp1,
    pp2: pp2,
    pp1String: JSON.stringify(pp1),
    pp2String: JSON.stringify(pp2)
  })
}

export function trackApiRequest(config) {
  config = config || {}
  var method = config.method || 'get'
  var pp1 = {
    trackType: 'api',
    trackName: method.toUpperCase() + ' ' + (config.url || ''),
    url: maskUrl(config.url || ''),
    method: method.toUpperCase(),
    params: sanitizeParams(config.params || {}),
    title: document.title || '',
    extra: config.extra || {}
  }
  var pp2 = getUserTrackBaseInfo()

  sendTrack({
    trackType: 'api',
    trackName: pp1.trackName,
    pp1: pp1,
    pp2: pp2,
    pp1String: JSON.stringify(pp1),
    pp2String: JSON.stringify(pp2)
  })
}



//////////////////
// WEBPACK FOOTER
// /resource/code/pmn3myn9-dev_repotest_1.5.412/packages/gaosiweb-common/js/userTrack.js
// module id = 5HtJ
// module chunks = 72